import type { ExternalPullRequest } from '../../types';

export const isExternalPullRequest = (entity: any): entity is ExternalPullRequest =>
	entity.__typename === 'ExternalPullRequest';

export const getExternalPullRequestLink = (pullRequest: ExternalPullRequest): string | null =>
	pullRequest?.url ?? null;
